<template> 
    <div>
        <el-row>
            <div style="float:right;">
            <el-form :inline="true" ref="searchForm" :model="similarRangeForm" :rules="searchFormRules">
                <el-form-item :label="itLoadRateLabel" prop="itLoadRate">
                    <el-input size="small" v-model="similarRangeForm.itLoadRateRange" placeholder="IT负载率上下浮动值"></el-input>
                </el-form-item>
                <el-form-item :label="wbtLabel" prop="itLoadRate">
                    <el-input size="small" v-model="similarRangeForm.wbtRange" placeholder="湿球温度上下浮动值"></el-input>
                </el-form-item>
                <!--
                <el-form-item>
                    <el-button type="primary" size="small" @click="handleSearchFormSubmit('searchForm')">查询</el-button>
                </el-form-item>
                -->
                <el-form-item>
                    <el-button type="primary" size="small" @click="similarRange2Default()">重置</el-button>
                </el-form-item>
            </el-form>   
            </div>
        </el-row>
        <el-row>
        <el-table :data="systemPUEAverageSimilarWorkConditionData" stripe  
            v-loading="tableLoading" element-loading-text="加载相似工况数据"
            height="350" style="width:100%">
            <el-table-column prop="name"       label="排序"         >
                <template slot-scope="scope">
                    <el-row>
                        {{scope.$index + 1}} 
                    </el-row>
                </template>
            </el-table-column>
            <el-table-column prop="puePhase"   label="PUE"          ></el-table-column>
            <el-table-column prop="tsdate"     label="日期"         >
                <template slot-scope="scope">
                    <el-row>
                        {{formateDate( scope.row.tsdate, scope.row.recordpointId )}} 
                    </el-row>
                </template>
            </el-table-column>
            <el-table-column prop="itLoadRate" label="IT负载率%"    ></el-table-column>
            <el-table-column prop="wbt"        label="湿球温度℃"   ></el-table-column>
        </el-table>
        </el-row>
    </div>
</template>

<script type="text/javascript">

import { Observable, Subject  } from 'rxjs' 
import { debounceTime } from 'rxjs/operators';

import { mapState, mapGetters, mapMutations, createNamespacedHelpers } from 'vuex';

import Big from 'big.js';
import * as Enumerable from "linq"

import { formatDate } from 'element-ui/src/utils/date-util'

import { uuid8 } from "@/util/common";

const pueStoreNSHelper = createNamespacedHelpers( "pue" );

export default {
    name: 'pue.similar.workcondition.table',
    components:{
    },
    props: {
        systemPUEAverageSimilarWorkConditionData : Array,
        systemPUESimilarConditionSP : Object,
        systemPUEAverageDataCurrentPeriod : Object,
        title : {
            type: String,
            default() {
                return "本周相似工况";
            }
        },
    },    
    data: () => {
        return {
            id : uuid8(),
            tableData: [],
            tableLoading : false,
            coreDataChagneObserver : new Subject(),
            searchFormRules : {
            
                wbtRange: [
                    { required: true, message: '必须填写数值', trigger: 'blur' },
                    { type: 'number', message: '必须为数字值'}
                ],
                itLoadRateRange: [
                    { required: true, message: '必须填写数值', trigger: 'blur' },
                    { type: 'number', message: '必须为数字值'}
                ]
            },
            itLoadRateLabel : "IT负载率",
            wbtLabel : "湿球温度",
        };
    },
    mounted: function () {
    
        const me = this;
        
        me.coreDataChagneObserver.pipe( debounceTime(200) ).subscribe(
            ( newValue ) => {             
                me.refreshTableData();
            }
        );
    },
    watch: {
        "systemPUEAverageSimilarWorkConditionData": {
            handler: function(newValue, oldValue) {
                const me = this;
                me.coreDataChagneObserver.next( newValue );
            },
            deep:true
        },
        "systemPUEAverageDataCurrentPeriod":{
             handler: function(newValue, oldValue) {
                const me = this;
                
                let iteLoadRate = me.systemPUEAverageDataCurrentPeriod.itLoadRate ? me.systemPUEAverageDataCurrentPeriod.itLoadRate.toFixed(2) : 0;
                let wbt         = me.systemPUEAverageDataCurrentPeriod.itLoadRate ? me.systemPUEAverageDataCurrentPeriod.wbt.toFixed(2) : 0;
                
                me.itLoadRateLabel = "IT负载率 " + iteLoadRate + "% ±";
                me.wbtLabel        = "湿球温度 " + wbt + "℃ ±";
            },
            deep:true
        },
    },
    computed: {
        ...pueStoreNSHelper.mapGetters( 
            {
            }
        ),
        similarRangeForm : {
            get () {
                return _.get( this.$store.state, "pue.similarRangeForm" , {} );
            },
            set (value) {
                this.$store.commit('pue/changeSimilarRangeForm', value)
            }
        },

    },
    methods: {
        ...pueStoreNSHelper.mapMutations(
            {
                 "changeSimilarRangeForm"                : "changeSimilarRangeForm",
            }
        ),
        openTableLoading() {
            const me = this;
            
            me.tableLoading = true;
            setTimeout(
                () => {
                    me.tableLoading = false;
                }, 20000
            );
        },
        closeTableLoading() {
            const me = this;
            
            me.tableLoading = false;
        },
        similarRange2Default(){
            
            const me = this;
            
            me.changeSimilarRangeForm(
                {
                    wbtRange : 1,
                    itLoadRateRange : 2
                }
            );  
        },
        formateDate( tsdate, recordpointId ){
        
             return formatDate( tsdate + 3600000*recordpointId , "yyyy-MM-dd HH:mm" );
        },
        refreshTableData(){
        
            const me = this;
        }
    }
}

</script>